import { subDays, isPast, differenceInDays, format } from "date-fns";
import { IBookings } from "../IBookings";
import { SCHEDULE_TYPES_IDS } from "../../../../../constants/common/offering";
import { checkIsObjectEmpty } from "../../../../../utils/common/dataTypes/object";
import { ADDRESS_TYPE } from "../../../../Offerings/constants/Offering.constants";
import { checkIsStringEmpty } from "../../../../Common/modules/DataTypes/utils/strings";
import { datetime_format_day_mon_year_time } from "../../../../Common/modules/DateTime/DateTime.constants";

export const getBookingCTAText = (booking: IBookings.IBookingData) => {
  switch (booking.listing_type) {
    case SCHEDULE_TYPES_IDS.WORKSHOP:
      return "Join Workshop";
    case SCHEDULE_TYPES_IDS.GROUP_CLASS:
    case SCHEDULE_TYPES_IDS.ROLLING_CLASS:
    case SCHEDULE_TYPES_IDS.ONE_ON_ONE_CLASS:
      return "Join Class";
    case SCHEDULE_TYPES_IDS.ONE_ON_ONE_APPOINTMENT:
      return "Join Appointment";
    case SCHEDULE_TYPES_IDS.MERCHANDISE:
      return "See Details";
    case SCHEDULE_TYPES_IDS.WA_COMMUNITY:
      return "Access Community";
    default:
      return "Join Session";
  }
};

export const isSlotWithinNUpcomingDays = (
  _sessionDate: string,
  days: number,
) => {
  const sessionDate = new Date(_sessionDate);
  const today = Date.now();

  // Calculate the date n days ago from today
  const newSessionDate = subDays(sessionDate, days);

  return differenceInDays(today, newSessionDate) >= 0;
};

export const isBookingExpired = (timestamp?: string | null) => {
  if (!timestamp) return false; // if timestamp is null or not defined then booking has no expiry date.
  return isPast(new Date(timestamp));
};
export const showPostBookingCTA = (booking: IBookings.IBookingData) => {
  return !checkIsStringEmpty(booking?.listing_metadata.post_booking_url);
};

export const getPostBookingCTAText = (
  booking: IBookings.IBookingData,
): string => {
  return booking?.listing_metadata?.post_booking_cta_text &&
    !checkIsStringEmpty(booking?.listing_metadata?.post_booking_cta_text)
    ? booking?.listing_metadata?.post_booking_cta_text
    : "Join Group";
};

export const getOfferingTiming = (booking: IBookings.IBookingData) => {
  if (checkIsObjectEmpty(booking)) return {};
  let startTime: string | undefined = "";
  let endTime: string | undefined = "";
  let startTimeString: string | undefined = "";
  let endTimeString: string | undefined = "";
  switch (booking.listing_type) {
    case SCHEDULE_TYPES_IDS.ONE_ON_ONE_CLASS:
    case SCHEDULE_TYPES_IDS.ROLLING_CLASS:
    case SCHEDULE_TYPES_IDS.GROUP_CLASS: {
      if (booking.cycle_start_time && booking.cycle_end_time) {
        startTime = booking.cycle_start_time;
        endTime = booking.cycle_end_time;
      }
      break;
    }

    case SCHEDULE_TYPES_IDS.ONE_ON_ONE_APPOINTMENT:
    case SCHEDULE_TYPES_IDS.WEBINAR: {
      if (booking.slots) {
        startTime = booking.slots[0].start_datetime;
        endTime = booking.slots[0].end_datetime;
      }
      break;
    }

    case SCHEDULE_TYPES_IDS.WORKSHOP: {
      if (
        booking.slots &&
        booking.slots &&
        booking.slots.length &&
        booking.slots[0].start_datetime &&
        booking.slots[0].end_datetime
      ) {
        startTime = booking?.slots[0].start_datetime;
        endTime = booking?.slots[booking?.slots.length - 1].end_datetime;
      }
      break;
    }

    default:
      break;
  }
  startTimeString =
    startTime && format(new Date(startTime), datetime_format_day_mon_year_time);
  endTimeString =
    endTime && format(new Date(endTime), datetime_format_day_mon_year_time);

  return { startTime, endTime, startTimeString, endTimeString };
};

export const getCourseCompletedBasedDesc = (percentage: number) => {
  if (percentage <= 0) {
    return "You haven't started yet :(";
  }
  return `${percentage}% Completed`;
};

export const getAddressBasedVenue = (
  listingAddressType: number,
  venueDetails?: IBookings.IVenueDetails,
) => {
  const response = {
    venue: "",
    joining_link: "",
    meta: {},
  };
  switch (listingAddressType) {
    case ADDRESS_TYPE.CUSTOMER_ADDRESS:
    case ADDRESS_TYPE.PERSONAL_ADDRESS:
      response.venue = venueDetails?.address || "";
      response.joining_link = "";
      break;
    case ADDRESS_TYPE.MEET_AUTO_GENERATE:
    case ADDRESS_TYPE.EXISTING_LINK:
      response.venue = venueDetails?.joining_link || "";
      response.joining_link = venueDetails?.joining_link || "";
      response.meta = { password: venueDetails?.joining_password };
      break;
    case ADDRESS_TYPE.WHATSAPP:
      response.venue = venueDetails?.whatsapp_link || "";
      response.joining_link = `tel:${venueDetails?.whatsapp_link}`;
      break;
    case ADDRESS_TYPE.PHONE_NUMBER:
      response.venue = venueDetails?.contact_number || "";
      response.joining_link = `tel:${venueDetails?.contact_number}`;
      break;
    case ADDRESS_TYPE.ZOOM_AUTO_GENERATE:
    case ADDRESS_TYPE.EXLY_CONNECT:
    case ADDRESS_TYPE.ZOOM_WEBINAR:
      response.venue = venueDetails?.exly_zoom_link_customer || "";
      response.joining_link = venueDetails?.exly_zoom_link_customer || "";
  }
  return response;
};
